<template>
    <div class="header">
        <b-row class="pr-5">
            <b-col cols="12" class="text-right py-3">
                <b-dropdown variant="success">
                    <template #button-content>
                        <span class="pl-2">{{$i18n.locale === 'en' ? "English" : $i18n.locale === 'zh' ? '繁體中文' : ''}}</span>
                    </template>
                    <b-dropdown-item @click="setLocale('en')">English</b-dropdown-item>
                    <b-dropdown-item @click="setLocale('zh')">繁體中文</b-dropdown-item>
                </b-dropdown>
            </b-col>
            <b-col cols="12" class="text-center">
                <img alt="Vue logo" src="../assets/logo.png">
            </b-col>
            <b-col cols="12" class="text-right">
                <span class="text-lightgreen">Powered By Nexsoft</span>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    methods: {
        setLocale(locale) {
            this.$i18n.locale = locale;
            this.$router.push({
                params: { lang: locale}
            })
        }
    }
}
</script>


<style scoped>
.header {
    background: #f9f9f9;
}
</style>